/**
* Booking CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Booking CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'booking-cta',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const blobs = gsap.utils.toArray( '.bg-gradient-linear-circle' );
      gsap.set( blobs[0], {scale: 0.5, transformOrigin: 'center center'} );
      gsap.set( blobs[1], {scale: 1, transformOrigin: 'center center'} );

      gsap.to( blobs[0], {
        scale: 1,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      } );

      gsap.to( blobs[1], {
        scale: 0.5,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'booking-cta', COMPONENT );
} )( app );
